import { render } from "./PrivacyPolicyContent.vue?vue&type=template&id=287b99d4"
import script from "./PrivacyPolicyContent.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyContent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__